import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reminders'),
      name: 'teletel_reminders_index',
      component: () => import('./Index.vue'),
      meta: {
        // Same list as the conversation routes, from the same source: a
        // hand-copied array here would drift the moment a permission is added.
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
    },
  ],
};
